import { createAction } from "redux-actions";
import {
  SET_LANGUAGE,
  SET_DATA_LINE,
  SET_FILTER_PART,
  SET_FILTER_PART_DES,
  SET_FILTER_CODE,
  SET_FILTER_TASK,
  SET_FILTER_VIV,
  SET_FILTER_VARIETY,
  SET_FILTER_BATCH,
  SET_FILTER_ARTICLE,
  SET_FILTER_LOCATION,
  SET_FILTER_SECT,
  SET_FILTER_USER,
} from "../../constants/index";
import { apiGet } from "../../api/index";
import { urlGetLoginItemTemp } from "../../api/urls";

/**
 * Set TimeZone.
 */
export const setLanguage = createAction(SET_LANGUAGE, (data) => data);

/**
 * Get item.
 */
export const getLoginItem = createAction("GET_ITEM", (token) =>
  apiGet(urlGetLoginItemTemp, [token], false)()
);

/**
 * Set TimeZone.
 */
export const setDataLine = createAction(SET_DATA_LINE, (data) => data);

/**
 * Set TimeZone.
 */
export const setFilterPart = createAction(SET_FILTER_PART, (data) => data);

/**
 * Set TimeZone.
 */
export const setFilterPartDes = createAction(
  SET_FILTER_PART_DES,
  (data) => data
);

export const setFilterCode = createAction(SET_FILTER_CODE, (data) => data);

export const setFilterTask = createAction(SET_FILTER_TASK, (data) => data);

export const setFilterViv = createAction(SET_FILTER_VIV, (data) => data);

export const setFilterVariety = createAction(SET_FILTER_VARIETY, (data) => data);

export const setFilterBatch = createAction(SET_FILTER_BATCH, (data) => data);

export const setFilterArticle = createAction(SET_FILTER_ARTICLE, (data) => data);

export const setFilterLocation = createAction(SET_FILTER_LOCATION, (data) => data);

export const setFilterSect = createAction(SET_FILTER_SECT, (data) => data);

export const setFilterUser = createAction(SET_FILTER_USER, (data) => data);









